import axios from '../helpers/Axios'

export default {

  async getDataSelection() {
    return await axios.get("/dataselection");
  },

  async saveAndCount(dataSelection) {
    return await axios.post("/dataselection/saveAndCount", dataSelection, {timeout: 1000 * 120});
  },

  async count() {
    return await axios.get("/dataselection/count", {timeout: 1000 * 120});
  },

  async getFilters() {
    return await axios.get("/dataselection/filters");
  },

  async getNextCompany() {
    return await axios.get("/dataselection/nextcompany");
  },

  async startCall(dataSelection) {
    return await axios.post("/dataselection/start", dataSelection, {timeout: 1000 * 120});
  },

}
